import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDpwjVxGHjgmogf8_kNd6KG7KT_TCa0F6o",
  authDomain: "frc-inventory-b7bb1.firebaseapp.com",
  projectId: "frc-inventory-b7bb1",
  storageBucket: "frc-inventory-b7bb1.firebasestorage.app",
  messagingSenderId: "845422036864",
  appId: "1:845422036864:web:668b96332b00d8f8322365"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);